import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Saisie from './pages/Saisie';
import Liste from './pages/Liste';
import Statistiques from './pages/Statistiques';
import Suivi from './pages/Suivi';
import SPC from './pages/SPC';
import Alertes from './pages/Alertes';
import Rapports from './pages/Rapports';
import Configuration from './pages/Configuration';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="saisie" element={<Saisie />} />
              <Route path="liste" element={<Liste />} />
              <Route path="statistiques" element={<Statistiques />} />
              <Route path="suivi" element={<Suivi />} />
              <Route path="spc" element={<SPC />} />
              <Route path="alertes" element={<Alertes />} />
              <Route path="rapports" element={<Rapports />} />
              <Route path="configuration" element={<Configuration />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

